import { RouteFn } from '@/hooks/use-flow';
import { useAction } from '@/hooks/use-action';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { BindContext } from '../../contexts/bind/bind-context';
import { Form } from '@/hooks/use-form-field';
import { BindForm as BindFormSchema } from '@/schemas/sceneDataSchema';
import { DynamicRenderer } from '@/components/DynamicUI/DynamicRenderer';
import useDynamicForm from '@/hooks/use-dynamic-form';

interface BindProviderProps {
  formData: BindFormSchema;
  route: RouteFn;
}

function bindKey(attribute: string) {
  return encodeFieldKey({ scope: 'bind', entity_index: 0, attribute: attribute });
}

export function BindForm({ formData, route }: BindProviderProps) {
  const { submitAsync, isLoading } = useAction();
  const form = useDynamicForm(formData.components);

  async function submitBind(paymentMethodNonce: string): Promise<void> {
    const valid = await form.trigger();
    if (!valid) return;
    if (isLoading) return;

    const data = {
      ...form.getValues(),
      [bindKey('payment_method_nonce')]: paymentMethodNonce,
    };

    await submitAsync(formData.action_name, data, route);
  }

  return (
    <BindContext value={{ submitBind }}>
      <Form {...form}>
        <DynamicRenderer
          form={form}
          components={formData.components}
          route={route}
          submit={() => {}}
        />
      </Form>
    </BindContext>
  );
}
